<div class="engagement-container">
    <button id="createReport" style="float: right;" (click)="openCreateModal()"> crear nuevo +</button>
    <table mat-table [dataSource]="params" aria-label="Tabla de informes">
        <ng-container matColumnDef="reportType">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">
                {{element.reportType}}
            </td>
        </ng-container>

        <ng-container matColumnDef="ob_Channel">
            <th mat-header-cell *matHeaderCellDef>Canal de contratacion </th>
            <td mat-cell *matCellDef="let element">
                {{element.ob_Channel}}
            </td>
        </ng-container>
        <ng-container matColumnDef="recipients">
            <th mat-header-cell *matHeaderCellDef>Destinatarios</th>
            <td mat-cell *matCellDef="let element">
                {{showRecipients(element.recipients)}}
            </td>
        </ng-container>
        <ng-container matColumnDef="periodicity">
            <th mat-header-cell *matHeaderCellDef>Periodo</th>
            <td mat-cell *matCellDef="let element">
                {{showPeriodicity(element.periodicity)}}
            </td>
        </ng-container>

        <ng-container matColumnDef="button">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Actualizar </th>
            <td class="text-center" mat-cell *matCellDef="let element">
                <img id="editReport" (click)="openCreateModal(element)" class="admin-icon" width="25px" style="cursor: pointer;" src="./assets/admin-icons/pencil.PNG"
                    alt="actualizar" title="Actualizar">

            </td>
        </ng-container>
        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Borrar </th>
            <td class="text-center" mat-cell *matCellDef="let element">
                <img id="deleteReport" (click)="openDeleteModal(element)" class="admin-icon" width="25px" style="cursor: pointer;" src="./assets/admin-icons/trash.PNG"
                    alt="Borrar" title="Borrar">

            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
